import React from "react";
import Link from "next/link";
import cx from "classnames";
import { useTranslation } from "react-i18next";

interface LinkProps {
  href?: string;
  label?: string;
  className?: string;
  color?: string;
  target?: string;
  [key: string]: any;
}

const View = ({
  label,
  children,
  style,
  className,
  target,
  color = "",
  href = "#",
  ariaLabel = "link",
  ...props
}: LinkProps) => {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language;

  return (
    <Link
      target={target}
      style={style}
      aria-label={ariaLabel}
      className={cx(`text-${color}`, {
        [`${className}`]: !!className,
      })}
      href={href}
      hrefLang={currentLocale}
      {...props}
    >
      {!!children ? children : label}
    </Link>
  );
};

export default View;
